import { Input, Component, OnInit, ElementRef, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-button',
  styleUrls: ['./button.component.scss'],
  templateUrl: './button.component.html'
})
export class ButtonComponent implements OnInit {
  @Output() onclick = new EventEmitter()

  // Constants
  private buttonTypes = {
    PRIMARY: 'btn-primary',
    SECONDARY: 'btn-secondary',
    TERTIARY: 'btn-tertiary',
    LIGHT: 'btn-light',
    DARK: 'btn-dark',
    SUCCESS: 'btn-success',
    DANGER: 'btn-danger',
    WARNING: 'btn-warning',
    INFO: 'btn-info',
    ACCENT: 'btn-accent',
    BLUE_D20: 'btn-blue-d20',
    BLUE_OUTLINE_D20: 'btn-outline-blue-d20'
  }

  private buttonSizes = {
    SMALL: 'btn-sm',
    LARGE: 'btn-lg',
    XLARGE: 'btn-xl',
    BLOCK: 'btn-block'
  }

  private buttonStyles = {
    OUTLINE: 'btn-outline',
    LINK: 'btn-link'
  }

  // UI Variables
  public class: string;
  private type: string = '';
  private style: string = '';
  private size: string = '';
  private block: string = '';

  // Inputs
  @Input() disabled: boolean | null;
  @Input() submitted: boolean | null;
  @Input() dataTest = 'btn';
  @Input() className = ''
  @Input() isLoading = ''

  private button: HTMLElement;

  constructor(
    private el: ElementRef,
    private changeDp: ChangeDetectorRef,
    ) {
    this.button = this.el.nativeElement as HTMLElement;
  }

  ngOnInit(): void {
    this.setButtonSize();
    this.setButtonStyle();
    this.setButtonType();
    this.setButtonClass();
    this.changeDp.detectChanges();
  }

  private setButtonType(): void {
    if (this.button.hasAttribute('primary')) {
      this.type = this.buttonTypes.PRIMARY;
    }
    else if (this.button.hasAttribute('secondary')) {
      this.type = this.buttonTypes.SECONDARY;
    }
    else if (this.button.hasAttribute('tertiary')) {
      this.type = this.buttonTypes.TERTIARY;
    }
    else if (this.button.hasAttribute('dark')) {
      this.type = this.buttonTypes.DARK;
    }
    else if (this.button.hasAttribute('light')) {
      this.type = this.buttonTypes.LIGHT;
    }
    else if (this.button.hasAttribute('success')) {
      this.type = this.buttonTypes.SUCCESS;
    }
    else if (this.button.hasAttribute('danger')) {
      this.type = this.buttonTypes.DANGER;
    }
    else if (this.button.hasAttribute('warning')) {
      this.type = this.buttonTypes.WARNING;
    }
    else if (this.button.hasAttribute('info')) {
      this.type = this.buttonTypes.INFO;
    }
    else if (this.button.hasAttribute('blue-d20')) {
      this.type = this.buttonTypes.BLUE_D20;
    }
    else if (this.button.hasAttribute('blue-outline-d20')) {
      this.type = this.buttonTypes.BLUE_OUTLINE_D20;
    }
    else if (this.button.hasAttribute('accent')) {
      this.type = this.buttonTypes.ACCENT;
    }
  }

  private setButtonStyle(): void {
    if (this.button.hasAttribute('outline')) {
      this.style = this.buttonStyles.OUTLINE;
    }
    else if (this.button.hasAttribute('link')) {
      this.style = this.buttonStyles.LINK;
    }
  }

  private setButtonSize(): void {
    if (this.button.hasAttribute('sm')) {
      this.size = this.buttonSizes.SMALL;
    }
    else if (this.button.hasAttribute('lg')) {
      this.size = this.buttonSizes.LARGE;
    }
    else if (this.button.hasAttribute('xl')) {
      this.size = this.buttonSizes.XLARGE;
    }
    if (this.button.hasAttribute('block')) {
      this.block = this.buttonSizes.BLOCK;
    }
  }

  private setButtonClass(): void {
    this.class = [this.type, this.size, this.style, this.block, this.className].join(' ');
  }

}
